'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _ExposureLogger2 = require('./ExposureLogger');
var _ExposureLogger3 = _interopRequireDefault(_ExposureLogger2);
var _egClickstreamSdkJs = require('eg-clickstream-sdk-js');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Exposure logger for logging experiment exposures using Clickstream + EGSP
 *
 * @implements {ExposureLogger}
 */
var EgspExposureLogger = function (_ExposureLogger) {
  _inherits(EgspExposureLogger, _ExposureLogger);

  /**
   * Constructor
   *
   * @param {EgClickstream} instance - egClickstream Instance
   * @param {object} callbacks (optional) contains callbacks to handle errors during egcs execution, it contains
   * @param {function} callbacks.onFetchError callback to be executed when fetch fails.
   * @param {function} callbacks.onInvalidPayload callback to be executed when payload sent to publish function is not valid.
   * @param {function} callbacks.onPublishError callback to be executed when publish function throw any error.
   */

  function EgspExposureLogger() {
    var instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var callbacks = arguments[1];
    _classCallCheck(this, EgspExposureLogger);
    var _this = _possibleConstructorReturn(this, (EgspExposureLogger.__proto__ || Object.getPrototypeOf(EgspExposureLogger)).call(this));
    _this._egc = instance ? instance : _egClickstreamSdkJs.instance.getNewInstance(callbacks);
    return _this;
  }
  /**
   * Log an experiment exposure using Clickstream + EGSP
   *
   * @param {EvaluationData} evaluationData
   * @param {string} [loggerParams.pageName] - the page the exposure event occurred on
   * @param {string} [loggerParams.clickstreamTraceId] - guid for trace context
   */

  _createClass(EgspExposureLogger, [{
    key: 'logExposure',
    value: function logExposure(evaluationData) {
      var loggerParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pageName = loggerParams.pageName;
      var clickstreamTraceId = loggerParams.clickstreamTraceId;
      if (this._shouldLogExposure(evaluationData)) {
        var exposureEvent = this._buildExposureEvent(evaluationData, pageName, clickstreamTraceId);
        var data = {
          event: exposureEvent,
          experience: {
            app_name: 'n/a',
            page_name: 'n/a',
            app_version: 'n/a'
          }
        };
        this._egc.publish(data);
      }
    }
  }, {
    key: '_buildExposureEvent',
    value: function _buildExposureEvent(evaluationData, pageName, clickstreamTraceId) {
      return {
        event_version: '1.0.0',
        event_name: 'experimentation.log',
        event_category: 'experimentation',
        event_type: 'EvaluationData',
        page_name: pageName,
        clickstream_trace_id: clickstreamTraceId,
        bucket: evaluationData.bucket.bucketValue,
        id: evaluationData.experimentKey.experimentId,
        instance_id: evaluationData.experimentInstanceId,
        entity_id: evaluationData.entityId,
        entity_type: evaluationData.entityType.entityTypeName,
        calculation_type: evaluationData.bucket.calculationType.typeIdentifier,
        run_type: evaluationData.runType
      };
    }
  }, {
    key: '_shouldLogExposure',
    value: function _shouldLogExposure(evaluationData) {
      return !evaluationData.exception && evaluationData.runType === 3;
    }
  }, {
    key: 'egc',
    value: function egc() {
      return this._egc;
    }
  }]);
  return EgspExposureLogger;
}(_ExposureLogger3.default);
exports.default = EgspExposureLogger;